import { IconButton } from "@sidelinesports/fan-design-system";
import { FeedIcon } from "@sidelinesports/icons";
import type { ComponentProps } from "react";

export const LiveFeedTriggerButton = (props: ComponentProps<"button">) => {
  return (
    // biome-ignore lint/correctness/useUniqueElementIds: Click triggered from <LatestEvent /> component
    <IconButton
      id="live-feed-trigger-button"
      icon={<FeedIcon />}
      size="lg"
      variant="outline-light"
      aria-label="Live Feed"
      {...props}
    />
  );
};
